export const baseUrl = 'https://egyptiancoach-6a357.firebaseapp.com';
export const voteUrl =
  'https://us-central1-egyptiancoach-6a357.cloudfunctions.net/app/vote';
export const deleteUrl =
  'https://us-central1-egyptiancoach-6a357.cloudfunctions.net/app/deletenode';
export const exportUrl =
  'https://us-central1-egyptiancoach-6a357.cloudfunctions.net/app/export';
export const notiUrl =
  'https://us-central1-egyptiancoach-6a357.cloudfunctions.net/app/notify';
export const title = 'Egyptian Coach Admin';

export const toolbarOptions = [
  'clean', 'bold', 'italic', 'underline', 'strike', 'link',{ 'list': 'ordered'}, { 'list': 'bullet' },{ 'script': 'sub'}, { 'script': 'super' }, { 'color': []}, { 'header': [1, 2, 3, 4, 5, 6, false] }];